import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import preProblem from './modules/prepareProblemListData.js'
import problemList from './modules/problemListData.js'
import solutionList from './modules/solutionListData.js'
import knowledgeList from './modules/knowledgeListData.js'
import hintList from './modules/hintListData.js'
import teamList from './modules/teamListData.js'

Vue.use(Vuex)

const state = {
  winHeight: 1000
}

const mutations = {
  SET_WIN_HEIGHT: (state, h) => {
    state.winHeight = h
  }
}

const actions = {
  SetWinHeight ({ commit }, h) {
    commit('SET_WIN_HEIGHT', h)
  }
}

const getters = {

}

const store = new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  modules: {
    user,
    preProblem,
    problemList,
    solutionList,
    knowledgeList,
    hintList,
    teamList
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js